import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";
import jels from './jelsReducer';
import meta from './metaReducer';
import tableUI from './tableUIReducer';

export const reduxStore = configureStore({
  reducer: {
    jels,
    meta,
    tableUI,
  },
  middleware: getDefaultMiddleware({
    thunk: true,
    immutableCheck: false,
    serializableCheck: false,
  })
});